import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';

@Component({
  selector: 'lfwms-bp-orand-cell-renderer',
  templateUrl: './orand-cell-renderer.component.html',
  styleUrls: ['./orand-cell-renderer.component.css']
})
export class OrAndCellRendererComponent implements ICellRendererAngularComp {

  public isLoading: boolean = true;
  public params: any;
  public templateId: number = 0;
  public cellValue: any = [];
  public cellDataRef: any = [];
  public cellDisplayValue: any;

  constructor() { }

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }


  public refresh(params: any): boolean {
    this.params = params;
    this.cellValue = this.params.value.cVal;
    return true;
  }

  public addLogicalOperation(operatorValue: string) {
    this.params.value.cVal = operatorValue;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-renderer/orand-cell-renderer.component.ts